const logs = [
  {
    path: '/logs/api',
    name: 'log-api',
    component: () => import('@/views/logs/Api.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_log_api',
      resource: 'all',
    },
  },
  {
    path: '/logs/audit',
    name: 'log-audit',
    component: () => import('@/views/logs/Audit.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_log_audit',
      resource: 'all',
    },
  },
  {
    path: '/logs/bills',
    name: 'log-bills',
    component: () => import('@/views/logs/Bills.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_log_bills',
      resource: 'all',
    },
  },
]

export default logs
